export default __webpack_public_path__ + "static/media/1 (15).7c798c9f.jpg";